import { environmentNames } from "./environmentNames";

export const environmentsMap = Object.freeze({
  ["mytruckadv-cdt.maersk.com"]: environmentNames.DEV,
  ["mytruck-cdt.maersk.com"]: environmentNames.TEST,
  ["mytruckedu-cdt.maersk.com"]: environmentNames.EDU,
  ["mytruck-stage.maersk.com"]: environmentNames.PREPROD,
  ["mytruck.maersk.com"]: environmentNames.PROD,
});
